import { isEqual } from 'lodash';
import ConfigureStore, { history } from './configureStore';
import { loadGeneral, loadUser, saveGeneral, saveUser } from './localStorage';

// Custom reducer state persistance
const persistedGeneral = loadGeneral();
const persistedUser = loadUser();

const { store } = ConfigureStore({ user: persistedUser, general: persistedGeneral });

let currentGeneral = persistedGeneral;
let currentUser = persistedUser;

store.subscribe(() => {
  const previousUser = currentUser;
  const reduxSnapshot = store.getState();

  currentGeneral = reduxSnapshot.general;
  currentUser = reduxSnapshot.user;

  if (!isEqual(persistedGeneral, currentGeneral)) saveGeneral(currentGeneral);
  if (!isEqual(previousUser, currentUser)) saveUser(currentUser);
});

export type AppDispatch = typeof store.dispatch;

export { history, store };
